import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCartAddedPopup = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  width: 390px;
  max-width: 100vw;
  background-color: ${({ theme }) => theme.white};
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 12px 24px -6px ${({ theme }) => theme.boxShadowColor};
  padding: 20px;
  z-index: 130;
  cursor: pointer;

  .cart-added-popup-header {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .cart-added-popup-icon {
    position: relative;
    width: 46px;
    height: 46px;
    min-width: 46px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }

    .countdown-ring {
      position: absolute;
      inset: 0;
      transform: rotate(-90deg);

      .countdown-ring-track {
        fill: none;
        stroke: ${({ theme }) => theme.lightGrey};
        stroke-width: 2;
      }

      .countdown-ring-progress {
        fill: none;
        stroke: ${({ theme }) => theme.brand02};
        stroke-width: 2;
        stroke-linecap: round;
        stroke-dasharray: 135.09;
        stroke-dashoffset: 0;
        animation: cart-added-popup-countdown 5s linear forwards;
      }
    }
  }

  &.wholesale .cart-added-popup-icon .countdown-ring .countdown-ring-progress {
    stroke: ${({ theme }) => theme.wholesale};
  }

  @keyframes cart-added-popup-countdown {
    to {
      stroke-dashoffset: -135.09;
    }
  }

  .cart-added-popup-title {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.black};
  }

  .cart-added-popup-divider {
    height: 1px;
    background-color: ${({ theme }) => theme.lightGrey};
    margin: 16px 0;
  }

  .cart-added-popup-product {
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .ant-image {
      width: 76px;
      height: 76px;
      min-width: 76px;

      img {
        width: 76px;
        height: 76px;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }

  .cart-added-popup-product-name {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.black};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .cart-added-popup-product-price {
    margin-top: 8px;
    font-size: 16px;
    color: ${({ theme }) => theme.grey};

    b {
      color: ${({ theme }) => theme.black};
      font-weight: 700;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    width: 100vw;
    border-radius: 0;
  }
`;
